'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _reactBootstrap = require('react-bootstrap');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

var _language2 = require('../../redux/modules/language');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = languageActions.isLoaded,
    loadDefinitions = languageActions.loadDefinitions,
    loadRecentWords = languageActions.loadRecentWords;
// const { loadLessonsWithFirstContent } = lessonActions;

var Translation = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        _ref$params = _ref.params,
        langType = _ref$params.langType,
        word = _ref$params.word,
        language = _ref$params.language;

    // console.log("asyncConnect");
    if (!isLoaded(getState())) {
      // console.log("not in here?");
      var promises = [];

      promises.push(dispatch(loadDefinitions(word, langType, language)));
      if (language === 'en') {
        promises.push(dispatch((0, _language2.analyzeSentence)(word, langType)));
      }

      promises.push(dispatch(loadRecentWords(1, language)));
      return _promise2.default.all(promises);
      // return dispatch();
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    definitions: state.language.definitions,
    definitions2: state.language.definitions2,
    recentWords: state.language.data
    // lessons_first_content: state.lesson.lessons_first_content
  };
}, (0, _extends3.default)({}, languageActions)
// lessonActions
), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = function (_Component) {
  (0, _inherits3.default)(Translation, _Component);

  function Translation() {
    (0, _classCallCheck3.default)(this, Translation);
    return (0, _possibleConstructorReturn3.default)(this, (Translation.__proto__ || (0, _getPrototypeOf2.default)(Translation)).apply(this, arguments));
  }

  (0, _createClass3.default)(Translation, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Home.scss');
      var _props = this.props,
          t = _props.t,
          definitions = _props.definitions,
          definitions2 = _props.definitions2,
          recentWords = _props.recentWords;

      var array = this.props.params.word.split(" ").map(function (item) {
        return item.toLowerCase();
      });

      // write a function that defines should we show translation for sentences.
      var isForSentences = function isForSentences() {
        var count = _this2.props.params.word.split(' ').length;
        if (count < 2) {
          return false;
        } else {
          return true;
        }
      };
      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement('p', null),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.SearchView, { onSubmit: function onSubmit(data) {
                console.log("hey");
                console.log(data);
                // data.q => this.props.history.push() 
                data.language = data.language === undefined ? 'en' : data.language;
                _this2.props.history.push('/' + _this2.props.params.language + '/translate/' + data.q + '/' + data.language);
              } })
          ),
          _react2.default.createElement(
            'div',
            null,
            _config2.default.is_for_personal_purpose && _react2.default.createElement(
              'div',
              null,
              'add your definition in your language || create an post for learning this.'
            ),
            _config2.default.is_for_personal_purpose && _react2.default.createElement(
              'div',
              null,
              'Find a sentence -> not found -> show a button for asking these words'
            ),
            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: t('content.definition_of', { word: this.props.params.word }) } }),
            _react2.default.createElement('p', null),
            _react2.default.createElement(
              _reactBootstrap.Grid,
              null,
              _react2.default.createElement(
                _reactBootstrap.Row,
                { className: 'show-grid' },
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { sm: 8, md: 8 },
                  definitions && definitions.map(function (item) {
                    // return (<p>{JSON.stringify(item)}</p>)
                    // check item type: normal
                    if (item.data === undefined) {
                      return;
                    }
                    if (item.data.length > 0) {
                      return _react2.default.createElement(
                        _reactBootstrap.Panel,
                        null,
                        item.data.map(function (def) {
                          // check user_id: => .... 
                          if (def.is_pron === undefined || def.is_pron === null) {
                            return _react2.default.createElement(
                              'p',
                              null,
                              def.definition,
                              ' ',
                              def.more_definition,
                              ' ',
                              def.long_definition,
                              ' ',
                              _react2.default.createElement(
                                'span',
                                null,
                                _config2.default.is_for_personal_purpose && def.user_id !== null && def.user_id !== undefined && _react2.default.createElement(
                                  _reactBootstrap.Button,
                                  { bsSize: 'xsmall', href: '/profile/' + def.user_id, onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this2.props.history.push('/profile/' + def.user_id);
                                    } },
                                  _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'glyphicon glyphicon-user' })
                                )
                              )
                            );
                          }
                        })
                      );
                    }
                  }),
                  isForSentences() && definitions2 && _react2.default.createElement(
                    _reactBootstrap.Panel,
                    null,
                    definitions2.map(function (item) {
                      // return (<p>{JSON.stringify(item)}</p>)
                      // check item type: normal

                      if (item.data.length > 0) {
                        return _react2.default.createElement(
                          'div',
                          null,
                          item.data.map(function (def) {
                            if (array.includes(def.word.toLowerCase())) {
                              // if (true) {
                              return _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                  'p',
                                  null,
                                  _react2.default.createElement(
                                    'b',
                                    null,
                                    def.word
                                  ),
                                  ' : ',
                                  def.definitions.map(function (item) {
                                    return item.definition;
                                  })
                                )
                              );
                            }

                            // return (<p>{def.definition} {def.more_definition} {def.long_definition}</p>);
                          })
                        );
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { sm: 4, md: 4 },
                  _react2.default.createElement(_components.NewWords, (0, _extends3.default)({ recentWords: recentWords }, this.props))
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Translation;
}(_react.Component)) || _class) || _class) || _class);
exports.default = Translation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Language/Translation.js
// module id = 1535
// module chunks = 0